export default class CustomizationHelper {

  constructor(customization, level) {
    this.customization = customization;
    this.level = level;
  }

  get method() {
    return this.customization.id ? 'PUT' : 'POST';
  }

  get programUrl() {
    return this.url('program');
  }

  get accountUrl() {
    return this.url('account');
  }

  get custPathIfPresent() {
    if(this.customization.id) {
      return `/${this.customization.id}`;
    }else {
      return '';
    }
  }

  get levelId() {
    return this.customization[`${this.level}_id`];
  }

  get url() {
    return `/admin/${this.level}s/${this.levelId}/customizations${this.custPathIfPresent}`
  }

}
